import classNames from 'classnames'
import React from 'react'
import {useEventDateInformation} from '../../../../../../commons/hooks/dates'
import sc from '../../classes.scss'
import s from './countdown.scss'
import {CountdownProps} from './interfaces'

export const Countdown = ({event, t, onImage}: CountdownProps) => {
  const {daysLeft} = useEventDateInformation(event.id)
  const text = daysLeft === 1 ? t('countdownOneDay') : t('countdownManyDays', {daysLeft})

  return (
    <div
      className={classNames(sc.textLineHeight, s.root, {
        [s.onImage]: onImage,
      })}
      data-hook="ev-countdown"
    >
      {text}
    </div>
  )
}
